<template>
  <v-dialog
    :value="true"
    max-width="800"
    persistent
  >
    <v-card
      style="position: relative"
    >
      <iframe
        width="100%"
        height="700"
        frameborder="0"
        src="about:blank"
        ref="iframe"
      ></iframe>
      <v-progress-circular
        v-if="loading"
        color="primary"
        size="30"
        style="position: absolute; left: 50%; top: 50%; margin-left: -15px; margin-top: -15px;"
        indeterminate
      />
      <v-btn
        icon
        style="position: absolute; top: 10px; right: 10px;z-index: 100"
        @click="$store.commit('setReturnsDialog', false)"
      >
        <v-icon>fa fa-times</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: true
    }
  },
  computed: {
    html () {
      return '' // return `<${'script'} src="https://....readyreturns.com/embed.js"></${'script'}>`
    }
  },
  mounted () {
    this.update()
    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
  methods: {
    update () {
      const iframe = this.$refs.iframe
      if (iframe) {
        iframe.contentWindow.document.open('text/htmlreplace')
        iframe.contentWindow.document.write(this.html)
        iframe.contentWindow.document.close()
      }
    }
  }
}
</script>
